/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SbSharedRefineMenuFilterLocation_viewer$ref = any;
export type SbSharedRefineMenuFilterLocationRefetchQueryVariables = {
    readonly uriRef: string;
    readonly userZipCode?: string | null;
};
export type SbSharedRefineMenuFilterLocationRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": SbSharedRefineMenuFilterLocation_viewer$ref;
    } | null;
};
export type SbSharedRefineMenuFilterLocationRefetchQuery = {
    readonly response: SbSharedRefineMenuFilterLocationRefetchQueryResponse;
    readonly variables: SbSharedRefineMenuFilterLocationRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "uriRef",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userZipCode",
            "type": "String",
            "defaultValue": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SbSharedRefineMenuFilterLocationRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SbSharedRefineMenuFilterLocation_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SbSharedRefineMenuFilterLocationRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": "isSearchWithinFilterEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "REFINE_MENU_SEARCH"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "locations",
                            "name": "facetSearch",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "facetName",
                                    "value": "location"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                },
                                {
                                    "kind": "Literal",
                                    "name": "page",
                                    "value": 1
                                },
                                {
                                    "kind": "Variable",
                                    "name": "uriRef",
                                    "variableName": "uriRef"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "zipCode",
                                    "variableName": "userZipCode"
                                }
                            ],
                            "concreteType": "FacetsQueryConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FacetsQueryEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "FilterValueType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "count",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "displayName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "urlLabel",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SbSharedRefineMenuFilterLocationRefetchQuery",
            "id": "app-buyer-finding/233.0.0-2019-09-19T10:07:06.974Z/SbSharedRefineMenuFilterLocationRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '5c7c0f058d0b5e39f0e230c759c7c34d';
export default node;
